<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h13">Acknowledgments</h1>
<p class="p0"><img alt="img5.png" src="Images/img5.png"/></p>
<p class="p11"> </p>
<p>Thank you for all you’ve done Jody, Tali, Cia, and Julie.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007.vue?17954980